export const ADFOX_COUNTRY = ['ru', 'kz', 'by', 'uz', 'kg'];